import styled from 'styled-components';

import { InputText } from 'ui/inputs';
import { FormField } from 'ui/formField';
import { ModalBody } from 'ui/modal';
import { caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Code = styled.code`
  background-color: ${colors.backgroundDestructiveSubtle};
  border-radius: ${spacing.quarter};
  color: ${colors.textDestructive};
  display: inline-block;
  padding: ${spacing.eighth} ${spacing.quarter};
`;

export const LabelSecondaryText = styled.span`
  color: ${colors.textSecondary};
`;

export const CustomHeaders = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const RateLimit = styled.div`
  align-items: center;
  display: flex;
`;

export const RateLimitInput = styled(InputText)`
  margin-left: ${spacing.double};
  width: ${pxToRem(140)};
  & > * {
    width: ${spacing.x6};
  }
`;

export const RateLimitText = styled.span`
  ${caption}
  color: ${colors.textSecondary};
  display: inline-block;
  margin: 0 0 0 ${spacing.half};
  padding: 0;
`;

export const StyledFormField = styled(FormField)`
  & > #df-edit-modal-rate-limit-input-error {
    margin-left: ${spacing.double};
  }
  & > * > label {
    margin-bottom: 0;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.plusHalf};
  > section {
    align-items: flex-start;
    column-gap: ${spacing.plusHalf};
    display: flex;
    > * {
      flex: 0 0 auto;
      margin-top: 0 !important;
      :first-child {
        flex: 1 1 auto;
      }
    }
  }
`;
